document.addEventListener('alpine:init', () => {
  var { getScript, getStylesheet } = Alpine.store('utilities');

  function productFormDeliveryTime(data = {}) {
    return {
      ...data,

      onIntersectDeliveryTime() {
        this.getAssets(() => this.kickoff());
      },

      kickoff() {
        var disabledDates = this.disabledDates;

        var regularProcessingDays = this.processingDays;
      
        var rushPrintingProcessingDays = this.processingDaysRushPrinting;
            rushPrintingProcessingDays -= 1;

        new Pikaday({
          field: this.$refs.inputDeliveryTime,
          format: 'dddd, MMMM Do YYYY',
          disableWeekends: true,
          disableDayFn: (date) => {
            var isDateDisabled = false;
      
            var dateYyyyMmDd = moment(date).format('YYYY-MM-DD');
      
            var isPastDate = moment(date).isBefore(moment());
      
            var processingDays = this.selectedIsRushPrinting ? rushPrintingProcessingDays : regularProcessingDays;
      
            var minDate = moment().businessAdd(processingDays, 'days');
      
            var isProcessingDay = moment(date).isBefore(minDate);
      
            if (isPastDate) {
              isDateDisabled = true;
            }
      
            if (isProcessingDay) {
              isDateDisabled = true;
            }
      
            if (disabledDates && disabledDates.indexOf(dateYyyyMmDd) > -1) {
              isDateDisabled = true;
            }
      
            return isDateDisabled;
          },
          onSelect: () => {
            this.$refs.inputDeliveryTime.dispatchEvent(new CustomEvent('input'));
          }
        });
      },

      getAssets(callback) {
        var pikadayScriptUrl = window.global.assetUrl['vendor-pikaday@1.8.2.js'];

        var pikadayStylesheetUrl = window.global.assetUrl['vendor-pikaday@1.8.2.css'];

        var momentScriptUrl = window.global.assetUrl['vendor-moment@2.14.1.js'];

        var momentBusinessScriptUrl = window.global.assetUrl['vendor-moment-business-days@1.2.0.js'];

        getScript((momentScriptUrl), () => getScript((momentBusinessScriptUrl), () => {
          getScript((pikadayScriptUrl), () => getStylesheet((pikadayStylesheetUrl), () => {
            callback();
          }));
        }));
      }
    };
  };

  Alpine.data('productFormDeliveryTime', productFormDeliveryTime);
});
